import z from 'zod'
import { createFileRoute } from '@tanstack/react-router'
import { requireAdmin } from '@/lib/auth-guards'
import { Users } from '@/features/users'
import { roles } from '@/features/users/data/data'

const usersSearchSchema = z.object({
  page: z.number().optional().catch(1),
  pageSize: z.number().optional().catch(10),
  role: z
    .array(z.enum(roles.map((r) => r.value as (typeof roles)[number]['value'])))
    .optional()
    .catch([]),
  q: z.string().optional().catch(''),
})

export const Route = createFileRoute('/_authenticated/users/')({
  beforeLoad: requireAdmin,
  validateSearch: usersSearchSchema,
  component: Users,
})
